import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useAllocationUtilityStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  absorbCell: {
    color: palette.shades[600]
  },
  absorbTitle: {
    margin: '16px 20px'
  },
  allocationUtility: {
    position: 'relative',
    '& + &': {
      marginTop: '18px'
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  correctionsTable: {
    background: palette.shades[300],
    boxShadow: 'none',
    marginBottom: '18px',
    padding: '24px 32px',
    '& .MuiAccordionSummary-root': {
      background: palette.gradients.white,
      flexDirection: 'row-reverse',
      padding: '24px 32px',
      borderTop: "1px solid ".concat(palette.shades[300]),
      borderBottom: "1px solid ".concat(palette.shades[300])
    },
    '&.Mui-expanded': {
      marginTop: '18px'
    },
    '& .MuiCollapse-entered': {
      borderBottom: "1px solid ".concat(palette.shades[300])
    },
    '& .MuiDataGrid-root': {
      boxShadow: 'none'
    }
  },
  disabledSwitch: {
    opacity: '0.5',
    pointerEvents: 'none'
  },
  dropArea: {
    width: '100%',
    height: '100%',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    transition: '0.2s',
    minHeight: '71px',
    fontSize: '17px',
    padding: '12px',
    textAlign: 'center',
    backgroundColor: "".concat(palette.shades[100]),
    '&:not(.active).drag': {
      backgroundColor: "".concat(palette.shades[200])
    },
    '&.active': {
      textAlign: 'left',
      '& input': {
        width: '1px',
        height: '1px'
      }
    },
    '& input': {
      top: '0',
      left: '0',
      opacity: '0',
      width: '100%',
      height: '100%',
      position: 'absolute',
      cursor: 'pointer',
      padding: '0',
      '&:focus': {
        outline: 'none'
      }
    },
    '&.disabled': {
      backgroundColor: "".concat(palette.shades[200]),
      opacity: '0.5',
      '& input': {
        cursor: 'auto'
      }
    }
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  utility: {
    width: '100%',
    padding: '24px 32px 24px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  utilityTitleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  utilityTitle: {
    marginLeft: '20px',
    marginRight: '20px'
  },
  allocationForm: {
    padding: '32px',
    position: 'relative',
    borderTop: "1px solid ".concat(palette.shades[300]),
    '& .MuiFormControl-root': {
      boxShadow: 'none'
    }
  },
  groupWrapper: {
    '&:not(:last-child)': {
      marginBottom: '24px'
    },
    '& .MuiFormControl-root': {
      display: 'flex'
    },
    '& .react-datepicker-wrapper': {
      display: 'block'
    }
  },
  groupWrapperContent: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('lg')]: {
      flexWrap: 'wrap'
    }
  },
  datePicker: {
    width: '100%',
    marginRight: '10px',
    '& > div': {
      display: 'block'
    }
  },
  attachFile: {
    flexGrow: '1',
    [breakpointsFunc.breakpoints.down('md')]: {
      maxWidth: '100%'
    },
    '&.attached': {
      padding: '16px 24px 8px 24px',
      border: '1px dashed #b8c4ce'
    }
  },
  flexBreakLg: {
    display: 'none',
    flexBasis: '100%',
    width: '0',
    marginTop: '24px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      display: 'block'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  flexBreakMd: {
    display: 'none',
    flexBasis: '100%',
    width: '0',
    marginTop: '24px',
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'block'
    }
  },
  fieldsSm: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('lg')]: {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: 'initial',
      flexGrow: '1',
      marginLeft: '0'
    }
  },
  field: {
    width: '110px',
    flexShrink: '0',
    [breakpointsFunc.breakpoints.down('lg')]: {
      flexGrow: '1'
    },
    '& + &': {
      marginLeft: '10px'
    }
  },
  billField: {
    marginRight: '10px',
    width: '140px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      marginRight: '0'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      marginLeft: '0',
      flexGrow: '1'
    }
  },
  customChargeOnDateDatePicker: {
    width: '300px',
    marginRight: '10px',
    display: 'flex'
  },
  summary: {
    background: palette.shades[200],
    display: 'flex',
    // justifyContent: 'space-between',
    alignItems: 'center',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  totalSummary: {
    '& .MuiTypography-root': {
      display: 'inline-block'
    }
  },
  detailsTable: {
    boxShadow: 'none',
    '& .MuiAccordionSummary-root': {
      background: palette.gradients.white,
      flexDirection: 'row-reverse',
      padding: '24px 32px',
      borderTop: "1px solid ".concat(palette.shades[300]),
      borderBottom: "1px solid ".concat(palette.shades[300])
    },
    '&.Mui-expanded': {
      margin: '0'
    },
    '& .MuiCollapse-entered': {
      borderBottom: "1px solid ".concat(palette.shades[300])
    },
    '& .MuiDataGrid-root': {
      boxShadow: 'none'
    }
  },
  table: {
    boxShadow: 'none',
    '& .MuiTableRow-root': {
      borderBottomWidth: '1px'
    },
    '& .MuiTableBody-root .MuiTableCell-root': {
      whiteSpace: 'nowrap'
    }
  },
  totalCell: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  totalCellData: {
    verticalAlign: 'middle'
  },
  calculateButton: {
    display: 'flex',
    marginLeft: '10px'
  },
  applyChargesButton: {
    marginLeft: '10px',
    justifyContent: 'flex-end'
  },
  rightAlign: {
    width: '100%',
    textAlign: 'right'
  },
  cellContent: {
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px'
  },
  cellContentWithTooltip: {
    cursor: 'pointer'
  },
  cellLeft: {
    width: '100%'
  },
  actionButton: {
    marginLeft: '10px'
  },
  billToggle: {
    marginRight: '10px'
  },
  paper: {
    height: '48px',
    width: '121px'
  },
  infoButton: {
    marginRight: '10px'
  },
  modalBody: {
    padding: '32px 40px'
  },
  modalFooter: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    textAlign: 'right'
  },
  formControlWithSuffix: {
    position: 'relative'
  },
  formControlWithSuffixOutput: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    userSelect: 'none',
    fontSize: 'inherit',
    paddingLeft: '12px',
    position: 'absolute',
    alignItems: 'center',
    visibility: 'hidden',
    lineHeight: 'inherit',
    fontFamily: 'inherit',
    pointerEvents: 'none'
  },
  formControlWithSuffixOutputValue: {
    overflow: 'hidden'
  },
  formControlWithSuffixOutputSuffixValue: {
    height: '100%',
    display: 'flex',
    paddingLeft: '2px',
    alignItems: 'center',
    visibility: 'visible'
  },
  accordionSummary: {
    paddingLeft: '24px'
  },
  utilityCredentialItemChip: {
    margin: '12px 0',
    width: '100%',
    '& .MuiChip-root': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      width: '100%'
    }
  },
  utilityStatus: {
    marginRight: '20px'
  },
  accordion: {
    zIndex: 'initial'
  },
  visibilitySetting: {
    display: 'flex',
    paddingTop: '8px',
    paddingLeft: '8px',
    alignItems: 'center',
    '& .MuiFormControlLabel-label': {
      marginRight: '4px'
    }
  },
  utilityBillStatus: {
    marginRight: '20px'
  },
  warning: {
    backgroundColor: palette.warning.light
  },
  amountLine: {
    marginTop: '16px'
  },
  unit: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px'
  }
}));
export default useAllocationUtilityStyles;